import axios from "../../../axios";

export default {
    async createTokenAction({ commit }, { email, password, ip }) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_API_BASE_URL + '/api/auth/login',
                {
                    email: email,
                    password: password,
                    ip: ip
                }
            )

            if (response.data.user && response.data.user.twofactor_activity) {
                // Novo fluxo de auth com 2FA pendente: limpa qualquer accessToken
                // residual de uma sessao anterior. Senao o request interceptor
                // (http/axios/index.js) injeta esse token velho/expirado no PATCH de
                // validacao do 2FA, sobrescrevendo o token fresco e causando 401
                // "Token is Invalid" antes do codigo TOTP ser validado.
                localStorage.removeItem('accessToken');
                commit('setLoginData', response.data);
                commit('setPermissionRoutes', { routes: response.data.has_permission_routes });
            } else {
                commit('setEmail', { email: email });
                commit('setToken', { token: response.data.access_token });
                commit('setOrigin', { value: response.data.origin_backoffice });
                commit('setPermissionRoutes', { routes: response.data.has_permission_routes });
            }

            return response;
        } catch (Exception) {
            commit('setToken', { token: "" })
            commit('setEmail', { email: "" })
            return 'Email ou/e senha errado(s)';
        }
    },

    async exitApplication(context, { ip }) {
        try {
            await axios.post(process.env.VUE_APP_API_BASE_URL + '/api/auth/logout', { data: "", ip: ip });
            context.commit('setToken', { token: "" });
        } catch (Exception) {
            context.commit('setToken', { token: "" });
        }
    },

    async userInfo({ commit }) {
        try {
            const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/api/auth/userInfo');
            commit('setPermissionRoutes', { routes: response.data.has_permission_routes });
            commit('UPDATE_USER_INFO', response.data.user);
        } catch (Exception) {}
    },

    async setName(context) {
        try {
            const email = localStorage.getItem('email')
            const name = await axios.post(process.env.VUE_APP_API_BASE_URL + "/api/users/email", { email: email })
            localStorage.setItem('name', name.data.name);
            context.commit('setName', { name: name.data.name });
        } catch (Exception) {
            context.commit('setName', { name: "" });
        }
    },

    async setEmail(context) {
        try {
            const email = await axios.post(process.env.VUE_APP_API_BASE_URL + "/api/users/email", { email: context.state.email })
            context.commit('setEmail', { email: email.data.email });
        } catch (Exception) {
            context.commit('setEmail', { email: "" });
            this.$store.dispatch('exitApplication', { token: context.state.token });
        }
    },

    async setNewEmail(context, { newEmail }) {
        localStorage.setItem('email', newEmail);
        context.commit('setEmail', { email: newEmail });
    },

    async setNewName(context, { newName }) {
        localStorage.setItem('name', newName);
        context.commit('setName', { name: newName });
    },

    setTenant(context, { tenant }) {
        try {
            context.commit("setTenant", { tenant: tenant });
            localStorage.setItem('tenant', tenant);
        } catch (Exception) {
            context.commit('setTenant', { tenant: "" });
            localStorage.setItem('tenant', "");
        }
    },

    async hasLogged({ commit, dispatch, getters }, { token }) {
        await dispatch('getAllUsers', { token: token })
        if (getters.users.length == 0) {
            commit('setHasLogged', { hasLogged: false })
        }
        else {
            commit('setHasLogged', { hasLogged: true })
        }
    },

    async alterEmail(context, { email }) {
        context.commit('setEmail', { email: email });
        localStorage.setItem('email', email);
    },

    async getId(context) {
        try {
            const id = await axios.post(process.env.VUE_APP_API_BASE_URL + "/api/users/email", { email: context.state.email })
            return id.data.id;
        } catch (Exception) {
            this.$store.dispatch('exitApplication', { token: context.state.token });
            return null;
        }
    },
    setToken(context, { token }) {
        context.commit('setToken', { token: token });
    }
}

